import Component from '@glimmer/component';
export default class RoombaSettingsExcludedEmailsComponent extends Component {
  get validationOptions() {
    return {
      allowBlank: false,
      in: this.args.rooms.map(room => room.name)
    };
  }
}